import { render, staticRenderFns } from "./instruct.vue?vue&type=template&id=635f8582&scoped=true&"
import script from "./instruct.vue?vue&type=script&lang=js&"
export * from "./instruct.vue?vue&type=script&lang=js&"
import style0 from "./instruct.vue?vue&type=style&index=0&id=635f8582&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635f8582",
  null
  
)

export default component.exports